<template>
	<div class="addInspectionStandard">
		<el-card>
			<!-- 返回列表页面 -->
			<div class="jump-btn">
				<el-button type="primary" @click="backToInspection()">{{$t('lang.btn_backToInspection')}}</el-button>
			</div>
			<el-form :model="form" :rules="rules" ref="form" :label-width="require('@/config/enum').c_w6"
				:label-suffix="require('@/config/enum').c_colon">
				<!-- 标准名称 -->
				<el-form-item :label="$t('lang.lbl_inspection_name')" prop="name">
					<el-input v-model="form.name"
						:placeholder="$t('lang.lab_please_Input') + $t('lang.lbl_inspection_name')" class="inputdis"
						maxlength="50"></el-input>
				</el-form-item>
				<!-- 报事一级分类 -->
				<el-form-item :label="$t('lang.lbl_inspection_typeName1')" prop="maintainType1">
					<el-select v-model="form.maintainType1" @change="changeSelect1">
						<el-option key :label="$t('lang.lbl_choose_inspection_typeName1')" :value="0"></el-option>
						<el-option v-for="(item,index) in maintainType1List" :key="index" :label="item.name"
							:value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<!-- 二级报事分类 -->
				<el-form-item :label="$t('lang.lbl_inspection_typeName2')" prop="maintainType2">
					<el-select v-model="form.maintainType2" @change="changeSelect2">
						<el-option key :label="$t('lang.lbl_choose_inspection_typeName2')" :value="0"></el-option>
						<el-option v-for="(item,index) in maintainType2List" :key="index" :label="item.name"
							:value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<!-- 三级报事分类 -->
				<el-form-item :label="$t('lang.lbl_inspection_typeName3')" prop="maintainType3">
					<el-select v-model="form.maintainType3" @change="changeSelect3">
						<el-option key :label="$t('lang.lbl_choose_inspection_typeName3')" :value="0"></el-option>
						<el-option v-for="(item,index) in maintainType3List" :key="index" :label="item.name"
							:value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<!-- 四级报事分类 -->
				<el-form-item :label="$t('lang.lbl_inspection_typeName4')" prop="maintainType4">
					<el-select v-model="form.maintainType4" @change="changeSelect4">
						<el-option key :label="$t('lang.lbl_choose_inspection_typeName4')" :value="0"></el-option>
						<el-option v-for="(item,index) in maintainType4List" :key="index" :label="item.name"
							:value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<!-- 五级报事分类 -->
				<el-form-item :label="$t('lang.lbl_inspection_typeName5')" prop="maintainType5">
					<el-select v-model="form.maintainType5">
						<el-option key :label="$t('lang.lbl_choose_inspection_typeName5')" :value="0"></el-option>
						<el-option v-for="(item,index) in maintainType5List" :key="index" :label="item.name"
							:value="item.id"></el-option>
					</el-select>
				</el-form-item>
				<!-- 是否需要照片 -->
				<el-form-item :label="$t('lang.lbl_isNecessaryPhotos')">
					<el-select v-model="form.havePhoto">
						<el-option v-for="(item,index) in havePhotoList" :key="index" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="是否允许跳过">
					<el-radio-group v-model="form.isSkip">
							<el-radio :label="1">允许跳过</el-radio>
							<el-radio :label="0">不允许跳过</el-radio>
						</el-radio-group>
				</el-form-item>
				<!-- 分数 -->
				<!-- <el-form-item :label="$t('lang.lbl_point')">
					<el-input-number v-model="form.point" size="medium" controls-position="right" :min="0" :max="999">
					</el-input-number>
				</el-form-item> -->
				<!-- 调查方式及抽样标准 -->
				<!-- <el-form-item :label="$t('lang.lbl_standardInfo')">
					<el-input type="textarea" rows="6" v-model="form.standardInfo" class="inputdis"
						:placeholder="$t('lang.lab_please_Input')+$t('lang.lbl_standardInfo')"></el-input>
				</el-form-item> -->

				<!-- 检查方法 -->
				<el-form-item :label="$t('lang.lbl_inspection_info')" prop="info">
					<el-input type="textarea" rows="6" v-model="form.info" class="inputdis"
						:placeholder="$t('lang.lab_please_Input')+$t('lang.lbl_inspection_info')"></el-input>
				</el-form-item>
				<!-- 上传图片 -->
				<el-form-item :label="$t('lang.lab_uploadPhotograph')" prop="urls" ref="urls">
					<upload-morefile ref="uploading" :accept='accept' upTypes='1' :fileList='filesList' :clears='clears'
						@outputFile="getFile" @removeFile='removeFile'></upload-morefile>
				</el-form-item>
				<el-form-item label="上传视频" prop="videoUrl" ref="videoUrl">
            <upload-video ref="uploading" :accept='acceptVideo' upTypes='2' :fileList='videoUrlFilesList' :clears='clears'
              @outputFile="getVideoUrlFile" @removeFile='removeVideoUrlFile'></upload-video>
        </el-form-item>
				<el-button @click="rest('form')" class="btn-first">{{$t('lang.btn_rest')}}</el-button>
				<el-button type="primary" @click="save('form')" class="detailbtn">{{$t('lang.btn_save')}}</el-button>
			</el-form>
		</el-card>
	</div>
</template>

<script>
	/**
	 *@ClassName:addInspectionStandard
	 *@Description:检查标准
	 *@author:李斌
	 *@Copyright:格众科技
	 *@date:2020-04-07
	 */
	import uploadmoreFile from '../../../components/upload_morefile.vue'
	import uploadvideo from '../../../components/upload_video.vue'
	export default {
		data() {
			return {
				accept: '.jpg, .jpeg, .png',
				acceptVideo: '.mp4',
				fileList: [], // 图片上传
				videoUrlFileList: [], // 视频上传
				clears: false, // 清空按钮
				isDisabled: true, // 按钮置灰
				saveData: '', // 存储json字符串
				editid: '', // 接收LIST页面的id
				type: 1, // 报事类型
				filesList: [],
				videoUrlFilesList: [],
				form: {
					name: '', // 标准名称
					maintainType1: 0, // 一级报事
					maintainType2: 0, // 二级报事
					maintainType3: 0, // 三级报事
					maintainType4: 0, // 四级报事
					maintainType5: 0, // 五级报事
					havePhoto: 1, // 是否需要照片
					isSkip: 0,
					info: '', // 检查方法
					urls: [], // 上传图片
					videoUrl: [], // 上传视频
					point: 0, // 分数
					standardInfo: '', // 调查方式及抽样标准
					gardenId: ''
				},
				rules: {
					name: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lbl_inspection_name'),
						trigger: 'blur'
					}],
					info: [{
						required: true,
						message: this.$i18n.t('lang.lab_please_Input') + this.$i18n.t('lang.lbl_inspection_info'),
						trigger: 'blur'
					}],
				},
				maintainType1List: [], // 一级报事列表
				maintainType2List: [], // 二级报事列表
				maintainType3List: [], // 三级报事列表
				maintainType4List: [], // 四级报事列表
				maintainType5List: [], // 五级报事列表
				havePhotoList: this.$i18n.t('lang.INSPECTIONSTANDARD.TYPE'), // 是否必传照片列表
			}
		},
		components: {
			'upload-morefile': uploadmoreFile,
			'upload-video': uploadvideo,
		},
		destroyed() {
			window.localStorage.setItem('addInspectionStandardform', JSON.stringify(this.form))
			window.localStorage.setItem('addInspectionStandardsaveData', JSON.stringify(this.saveData))
		},
		created() {
			this.form.gardenId = this.$store.getters.gardenId
			this.getmaintainTypeList()
			// 接收编辑页面参数
			if (this.$route.query.id) {
				this.editid = this.$route.query.id
				if (window.localStorage.getItem('addInspectionStandardform')) {
					this.form = JSON.parse(window.localStorage.getItem('addInspectionStandardform'))
					if (this.form.urls) {
						this.filesList.push({
							name: '',
							url: this.form.urls
						})
					}
					if (this.form.videoUrl) {
						this.videoUrlFilesList.push({
							name: '',
							url: this.form.videoUrl
						})
					}
					if (window.localStorage.getItem('addInspectionStandardsaveData')) {
						this.saveData = JSON.parse(window.localStorage.getItem('addInspectionStandardsaveData'))
					}
				} else {
					this.patrolStandardById()
					if (this.$route.query.maintainType1) {
						this.form.maintainType1 = Number(this.$route.query.maintainType1)
					}
					if (this.$route.query.maintainType2) {
						this.form.maintainType2 = Number(this.$route.query.maintainType2)
					}
					if (this.$route.query.maintainType3) {
						this.form.maintainType3 = Number(this.$route.query.maintainType3)
					}
					if (this.$route.query.maintainType4) {
						this.form.maintainType4 = Number(this.$route.query.maintainType4)
					}
					if (this.$route.query.maintainType5) {
						this.form.maintainType5 = Number(this.$route.query.maintainType5)
					}
				}

				// 判断报事分类是否为0
				if (this.form.maintainType1 === 0) {
					this.maintainType2List = []
					this.form.maintainType2 = 0
					this.maintainType3List = []
					this.form.maintainType3 = 0
					this.maintainType4List = []
					this.form.maintainType4 = 0
					this.maintainType5List = []
					this.form.maintainType5 = 0
				} else {
					this.type = 2
					this.getmaintainTypeOther(this.form.maintainType1)
				}
			}
		},
		watch: {
			form: {
				handler(newVal, oldVal) {
					let tempRule = JSON.stringify(newVal)
					if (tempRule === this.saveData) {
						this.isDisabled = true
					} else {
						this.isDisabled = false
					}
				},
				deep: true,
				immediate: true
			}
		},
		methods: {
			// 获取组件值
			getFile(e) {
				this.isDisabled = false
				this.fileList.push({
					name: '',
					url: e
				})
			},
			// 移除图片
			removeFile(e) {
				let list1 = []
				for (let i = 0; i < this.fileList.length; i++) {
					if (this.fileList[i].url === e) {

					} else {
						list1.push(this.fileList[i])
					}
				}
				this.fileList = list1
				this.filesList = JSON.parse(JSON.stringify(list1))
				this.isDisabled = false
			},
			// 获取视频
			getVideoUrlFile(e, f) {
				this.isDisabled = false
        this.videoUrlFileList.push({
          name: f,
          url: e
        })
			},
			// 移除视频
			removeVideoUrlFile(e) {
				let list = []
        for (let i = 0; i < this.videoUrlFileList.length; i++) {
          if (this.videoUrlFileList[i].url === e) {
          } else {
            list.push(this.videoUrlFileList[i])
          }
        }
        this.videoUrlFileList = list
        this.videoUrlFilesList = JSON.parse(JSON.stringify(list))
        this.isDisabled = false
			},
			// 返回列表页面
			backToInspection() {
				this.$router.push({
					name: 'InspectionStandardList'
				})
			},
			patrolStandardById() {
				let loading = this.$loading()
				this.$get(`/patrolStandardById/` + this.editid).then(res => {
						loading.close()
						if (res && res.errCode === 0) {
							this.form = res
							if (this.form.maintainType2 === null) {
								this.form.maintainType2 = 0
							}
							if (this.form.maintainType3 === null) {
								this.form.maintainType3 = 0
							}
							if (this.form.maintainType4 === null) {
								this.form.maintainType4 = 0
							}
							if (this.form.maintainType5 === null) {
								this.form.maintainType5 = 0
							}
							this.filesList = []
							this.fileList = []
							if (res.urls && res.urls.length > 0) {
								for (let i = 0; i < res.urls.length; i++) {
									this.filesList.push({
										name: '',
										url: res.urls[i]
									})
									this.fileList.push({
										name: '',
										url: res.urls[i]
									})
								}
							}
							this.videoUrlFilesList = []
							this.videoUrlFileList = []
							if (res.videoUrl) {
								let videoUrlArr = res.videoUrl.split(',')
								if (videoUrlArr && videoUrlArr.length > 0) {
									for (let i = 0; i < videoUrlArr.length; i++) {
										this.videoUrlFilesList.push({
											name: videoUrlArr[i].split('|')[1],
											url: videoUrlArr[i].split('|')[0]
										})
										this.videoUrlFileList.push({
											name: videoUrlArr[i].split('|')[1],
											url: videoUrlArr[i].split('|')[0]
										})
									}
								}
							}
							this.saveData = JSON.stringify(res)
							console.log(this.saveData)
						}
					},
					error => {
						loading.close()
						this.$message.error(error)
					})
			},
			// 初始化，获取一级报事列表
			getmaintainTypeList() {
				this.$get(`maintainTypes/?type=${this.type}&pageSize=999&pageNo=1&parentId=${this.form.gardenId}`).then(res => {
						if (res && res.errCode === 0) {
							this.maintainType1List = res.list
						}
					},
					error => {
						this.$message.error(error)
					}
				)
			},
			// 初始化获取二三级列表
			getmaintainTypeOther(Pid) {
				this.$get(`maintainTypes/?type=${this.type}&Pid=${Pid}&pageSize=999&pageNo=1`).then(res => {
						if (res && res.errCode === 0) {
							if (this.type === 2) {
								this.maintainType2List = res.list
								if (this.form.maintainType2 === 0 || this.form.maintainType2 === null) {
									this.form.maintainType2 = 0
									this.maintainType3List = []
									this.form.maintainType3 = 0
								} else {
									this.type = 3
									this.getmaintainTypeOther(this.form.maintainType2)
									return
								}
							}
							if (this.type === 3) {
								this.maintainType3List = res.list
								if (this.form.maintainType3 === 0 || this.form.maintainType3 === null) {
									this.form.maintainType3 = 0
									this.maintainType4List = []
									this.form.maintainType4 = 0
								} else {
									this.type = 4
									this.getmaintainTypeOther(this.form.maintainType3)
									return
								}
							}
							if (this.type === 4) {
								this.maintainType4List = res.list
								if (this.form.maintainType4 === 0 || this.form.maintainType4 === null) {
									this.form.maintainType4 = 0
									this.maintainType5List = []
									this.form.maintainType5 = 0
								} else {
									this.type = 5
									this.getmaintainTypeOther(this.form.maintainType4)
									return
								}
							}
							if (this.type === 5) {
								this.maintainType5List = res.list
							}
						}
					},
					error => {
						this.$message.error(error)
					})
			},
			// 点击选择一级报事，获取二级报事列表
			changeSelect1() {
				this.type = 2
				this.getmaintainTypeOther(this.form.maintainType1)
				this.form.maintainType2 = 0
				this.maintainType3List = []
				this.form.maintainType3 = 0
				this.maintainType4List = []
				this.form.maintainType4 = 0
				this.maintainType5List = []
				this.form.maintainType5 = 0
			},
			// 点击选择二级报事，获取三级报事列表
			changeSelect2() {
				this.type = 3
				this.getmaintainTypeOther(this.form.maintainType2)
				this.form.maintainType3 = 0
				this.form.maintainType4 = 0
				this.form.maintainType5 = 0
			},
			// 点击选择三级报事，获取四级报事列表
			changeSelect3() {
				this.type = 4
				this.getmaintainTypeOther(this.form.maintainType3)
				this.form.maintainType4 = 0
				this.form.maintainType5 = 0
			},
			// 点击选择四级报事，获取五级报事列表
			changeSelect4() {
				this.type = 5
				this.getmaintainTypeOther(this.form.maintainType4)
				this.form.maintainType5 = 0
			},
			save(formName) {
				this.$refs[formName].validate(valid => {
					if (valid) {
						if (this.editid === '') {
							let loading = this.$loading()
							if (this.fileList.length > 0) {
								for (let i = 0; i < this.fileList.length; i++) {
									if (this.fileList[i].url.indexOf('blob') != -1) {
										this.filesList.push(this.fileList[i].response.data[0])
									} else {
										this.filesList.push(this.fileList[i].url)
									}
								}
							}
							if (this.videoUrlFileList.length > 0) {
								for (let i = 0; i < this.videoUrlFileList.length; i++) {
									if (this.videoUrlFileList[i].url.indexOf('blob') != -1) {
										this.videoUrlFilesList.push(this.videoUrlFileList[i].response.data[0])
									} else {
										let urlName = this.videoUrlFileList[i].url.replace('http://114.55.43.117:8090/getPic', 'http://zhwyjk.kmyhwy.cn/webPic') + '|' + this.videoUrlFileList[i].name
										this.videoUrlFilesList.push(urlName)
									}
								}
							}
							let params = {
								name: this.form.name,
								maintainType1: this.form.maintainType1,
								maintainType2: this.form.maintainType2,
								maintainType3: this.form.maintainType3,
								maintainType4: this.form.maintainType4,
								maintainType5: this.form.maintainType5,
								info: this.form.info,
								havePhoto: this.form.havePhoto,
								isSkip: this.form.isSkip,
								point: this.form.point,
								standardInfo: this.form.standardInfo,
								files: this.filesList.toString(),
								videoUrl: this.videoUrlFilesList.toString(),
								gardenId: this.form.gardenId
							}
							this.$get(`/groupsByGardenId/` + this.form.gardenId).then(
								res => {
									if (res.list.length > 0) {
										this.$post(`/patrolStandard`, params).then(
											res => {
												loading.close()
												if (res && res.errCode === 0) {
													this.$message.success(this.$i18n.t(
														'lang.lab_save_success'))
													var index = this.$keepAlive.indexOf(
														'/manage/main.patrolStandardList')
													if (index > -1) {
														this.$keepAlive.splice(index, 1)
													}
													this.backToInspection()
												}
											},
											error => {
												loading.close()
												this.$message.error(error)
											}
										)
									} else {
										loading.close()
										this.$message.error(this.$i18n.t('此小区未设置集团，请先设置集团。'))
									}
								},
								err => {
									loading.close()
									this.$message.error(err)
								})
							} else {
							let loading = this.$loading()
							if (this.fileList.length > 0) {
								this.filesList = []
								for (let i = 0; i < this.fileList.length; i++) {
									if (this.fileList[i].url.indexOf('blob') != -1) {
										this.filesList.push(this.fileList[i].response.data[0])
									} else {
										this.filesList.push(this.fileList[i].url)
									}
								}
							}
							if (this.videoUrlFileList.length > 0) {
								this.videoUrlFilesList = []
								for (let i = 0; i < this.videoUrlFileList.length; i++) {
									if (this.videoUrlFileList[i].url.indexOf('blob') != -1) {
										this.videoUrlFilesList.push(this.videoUrlFileList[i].response.data[0])
									} else {
										let urlName = this.videoUrlFileList[i].url.replace('http://114.55.43.117:8090/getPic', 'http://zhwyjk.kmyhwy.cn/webPic') + '|' + this.videoUrlFileList[i].name
										this.videoUrlFilesList.push(urlName)
									}
								}
							}
							let params = {
								name: this.form.name,
								maintainType1: this.form.maintainType1,
								maintainType2: this.form.maintainType2,
								maintainType3: this.form.maintainType3,
								maintainType4: this.form.maintainType4,
								maintainType5: this.form.maintainType5,
								info: this.form.info,
								havePhoto: this.form.havePhoto,
								isSkip: this.form.isSkip,
								point: this.form.point,
								standardInfo: this.form.standardInfo,
								files: this.filesList.toString(),
								videoUrl: this.videoUrlFilesList.toString(),
							}
							this.$patch(`/patrolStandard/${this.editid}`, params).then(
								res => {
									loading.close()
									if (res && res.errCode === 0) {
										this.$message.success(this.$i18n.t('lang.lab_save_success'))
										var index = this.$keepAlive.indexOf('/manage/main.patrolStandardList')
										if (index > -1) {
											this.$keepAlive.splice(index, 1)
										}
										this.backToInspection()
									}
								},
								error => {
									loading.close()
									this.$message.error(error)
								}
							)
						}
					}
				})
			},
			// 清空
			rest(form) {
				this.clears = true
				this.$refs.form.clearValidate()
				this.form.name = ''
				this.form.maintainType1 = 0
				this.maintainType2List = []
				this.form.maintainType2 = 0
				this.maintainType3List = []
				this.form.maintainType3 = 0
				this.maintainType4List = []
				this.form.maintainType4 = 0
				this.maintainType5List = []
				this.form.maintainType5 = 0
				this.form.havePhoto = 0
				this.form.isSkip = 1
				this.form.info = ''
				this.form.urls = ''
				this.fileList = []
				this.videoUrlFileList = []
			},
		}
	}
</script>

<style lang='scss'>
	.addInspectionStandard {
		.inputdis {
			width: 50%;
		}
	}
</style>